
import { bindServiceWorker, IServiceWorker } from '../interface/serviceworker';
import { injectENV, injectFetch } from '../interface/util';
import { injectConfigCache } from '../interface/config';
import { IContainer } from '../interface/container';

export function bind(container: IContainer): Promise<void> {
    let val: IServiceWorker|null = null;

    const resolver = () => {
        return new Promise<IServiceWorker>(async function(resolve, reject) {
            let rejection = null;

            try {
                if ( !val ) {
                    const worker = await import('./worker');
                    const fetcher = await injectFetch(container);
                    const cacheConfig = await injectConfigCache(container);
                    const env = await injectENV(container);

                    /* limit SW visibility to base subpath of PWA, scope *must* end with slash '/qc/mauto' -> '/qc/mauto/' */
                    let scope = env.getString('REACT_APP_ROUTE_BASENAME') ?? '.'; 

                    if ( !scope.endsWith('/') ) {
                        scope = scope + '/';
                    }

                    /* do not add path-prefix, it is auto added as part of the base href tag */ 
                    const swUrl = 'service-worker.js';

                    val = worker.default(
                        fetcher,
                        cacheConfig,
                        swUrl,
                        scope);
                }
            } catch (error) {
                rejection = error;
            }

            if ( val ) { resolve(val); }
            else { reject(rejection || 'Import failed for worker'); }
        });
    }

    bindServiceWorker(resolver, container);

    return Promise.resolve();
}
